import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) =>
  (data: {
    accountNumber: string;
    beneficiaryName: string;
    code: string;
    country: string;
    currency: string;
    homeAddress: string;
    iban: string;
    ownerName: string;
    paypalEmail: string;
    customerUUID: string;
    type: 'iban' | 'paypal' | 'bank';
  }) =>
    makeCall<undefined>('POST', `/api/v2/user/me/payout-method`, {
      data,
    });
